// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1TLMP","requiredAsterisk":"Info_requiredAsterisk__1V46b"};